import React, {ChangeEvent, Dispatch} from 'react';
import {ReactComponent as SearchIcon} from '../../../../../../../assets/main/test/search.svg';
import {ReactComponent as PlusIcon} from '../../../../../../../assets/main/groups/main-table/period-calendar/plus.svg';
import {NavLink} from "react-router-dom";

interface IMyTestSearchProps {

    onSearchInputChange: (value: string) => void;
}

export const MyTestSearch = (
    {
        onSearchInputChange,
    }: IMyTestSearchProps) => {

    const handleInputChange = (e: ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;

        onSearchInputChange(value);
    };

    const handleFormSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
    };

    return (
        <div className="data-tbl-controls no-border">
            <form className="search-form" onSubmit={handleFormSubmit}>
                <input
                    type="text"
                    className="form-control"
                    placeholder="Поиск"
                    onChange={handleInputChange}
                />
                <button type="button" className="search-btn">
                    <SearchIcon/>
                </button>
            </form>
            <NavLink to="/test/add-test" className="btn small has-icon">
                 <span className="icon">
                    <PlusIcon/>
                 </span>
                <span>Создать тест</span>
            </NavLink>
        </div>
    );
};


